import script from "./BaseDropdownComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDropdownComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDropdownComponent.vue?vue&type=style&index=0&id=27cf4cae&lang=css"

const __exports__ = script;

export default __exports__